import type { aide as Fr } from '../fr/aide';

/** « aide » in English — typed on the French: a missing sentence does not compile. */
export const aide: typeof Fr = {
  titre: (poste: string) => `${poste} guide`,
  sousTitre: (pour: string) => `How to use the software in your role — ${pour}`,
  imprimer: 'Print this guide',
  leVotre: ' · yours',
  aRetenir: 'Remember',
};
